
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';
import HeroSection from './components/HeroSection';
import ContactFormSection from './components/ContactFormSection';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Breadcrumb />
      <main>
        <HeroSection />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
